import React from 'react'

function Homebox3() {
    return (
        <div className='homebox2main'>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-right'>
                        <h5>Built to scale with your business</h5>
                        <p>Whether you run one store or multiple locations, Loopy Loyalty helps you manage cards, staff, and customers from one central platform.</p>
                        <h5>Simplify and automate operations</h5>
                        <p>Connect customer and visit data with your existing tools to automate your loyalty program and reduce manual work.</p>
                        <h5>Smart loyalty automation</h5>
                        <p>Automatically manage stamps, rewards, and customer notifications through integrations and automation tools like Zapier.</p>
                        <h5>Real-time customer insights</h5>
                        <p>Sync live join, visit, and reward data directly with your CRM or email platforms no manual spreadsheets required.</p>
                    </div>
                    <div className='homebox2-left'>
                        <img src="/image-12.png" alt="hero-img" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Homebox3